import React from 'react'

import joshuaEMedow from "./images/JoshuaEMedow.jpeg";
import jenniferCarter from "./images/JenniferCarter.jpeg";

import jimSendecke4 from "./images/jimSendecke.png";
import bobOkeefe2 from "./images/bob_okeefe.png"
import mikeYaktus2 from "./images/MikeYaktus.png";

import tonyFrey from "./images/TonyFrey.jpeg";
import anneRose from "./images/AnneRose.jpeg";
import timGaillard from "./images/TimGaillard.jpeg";
import rockMackie from "./images/RockMackie.jpeg";

import aimeeArnoldussen from "./images/AimeeArnoldussen.png";
import bobMcDonald from "./images/BobMcDonald.png";
import onur from "./images/Onur.png";

import "./Team.css";
import { TeamTitle } from "./Team.style";

import TeamMember from "./TeamMember";
import PageTitle from '../../../components/pageTitle/PageTitle';
import AboutNav from '../../../components/aboutnav/AboutNav';
import SEO from '../../../components/seo/SEO';

const Team = () => {
  return (
    <>
    <SEO
        title="Team"
        description="Meet Our Award-Winning Team"
      />
      {/* <PageTitle
        title={"Meet Our Award-Winning Team"}
        breadcrumb={[
          { url: "/about", desc: "About" },
          {
            url: "/about/team",
            desc: "Team",
          },
        ]}
      /> */}
      <AboutNav/>
      <section id="page-content" className='pt-5'>
        <div className="container mt-5" style={{maxWidth:"1100px"}}>
        <div className="row my-6">
            <div className="col-lg-6">
              <div className="mb-3">
                <TeamTitle>Leadership</TeamTitle>
              </div>
              <div className="row">
                <TeamMember
                  img={joshuaEMedow}
                  name={
                    "Joshua E. Medow, MD, MSc, PhD, FAANS, FACS, FNCS, FAHA, FCCM"
                  }
                  job={"Chief Executive Officer (CEO)"}
                  largetext={true}
                  text={
                    "Joshua Medow MD, MSc, PhD, FAANS, FACS, FNCS, FAHA, FCCM is a Tenured Professor of Neurological Surgery and Biomedical Engineering.  He served as the Director of Neurocritical Care and the Vice Chair of Quality at the University of Wisconsin Hospital in Madison from 2008-2023.  He received his B.S degree from the University of Illinois Urbana-Champaign in 1995, his M.D. degree from the University of Illinois Chicago in 1999, and an M.Sc. degree in Clinical Investigation from University of Wisconsin Madison in 2010 and his PhD in Clinical Investigation / Informatics in 2019.  He completed his residency in neurosurgery, training in critical care medicine, and fellowship in endovascular neurosurgery at the University of Wisconsin School of Medicine and Public Health in 2006 and 2008 respectively.  Dr. Medow founded the UW neurocritical care program, which includes a state of the art, 18-bed, dedicated Neuro ICU with multimodality monitoring.  He is quadruple boarded in neurosurgery, neurocritical care neurology, neurocritical care neurosurgery, and clinical informatics.  Dr. Medow has received numerous awards for excellent patient care and for teaching and research.  His clinical focus is on improving outcomes and reducing costs in healthcare.  In his first year as faculty, the neurocritical care program that he founded reduced mortality by 43% in the sickest patients and simultaneously saved nearly $3 million in costs.  His lab is formed by a multidisciplinary group of people that come from engineering, computer science, informatics, and the allied health professionals that care for patients at the bedside.  He has presented in many forums about complex case management.  His translational research focuses device development and on AI decision support algorithm development.  His work in AI has culminated in a software product known as the Digital Intern which improves quality and cost savings in value driven healthcare delivery through a standard approach to personalized medicine.  A spinoff company from the University of Wisconsin, Vital Medical Dynamics, actively produces the Digital Intern software and manages the sizeable knowledgebase behind the many decision support modules in its library."
                  }
                />
                

                <TeamMember
                  img={tonyFrey}
                  name={"Tony Frey"}
                  job={"Integration and Interface Expert"}
                  text={
                    "Tony Frey implemented the Digital Intern algorithms at the University of Wisconsin. He has over 18 years experience in healthcare IT."
                  }
                />

                <TeamMember
                  img={anneRose}
                  name={"Anne Rose, PharmD"}
                  job={"Clinical Librarian"}
                  text={
                    "Dr. Rose is iVMD’s clinical librarian. She is an inpatient pharmacy manager of patient care services focusing on internal medicine and cardiology. She also manages the Anticoagulation Stewardship Program and Anticoagulation Clinic at the University of Wisconsin Hospital and Health System (UW Health) located in Madison, Wisconsin. Dr. Rose received her PharmD degree from Butler"
                  }
                />
                <TeamMember
                  img={bobMcDonald}
                  name={"Bob McDonald"}
                  largetext={true}
                  job={"Director of Business Development"}
                  text={
                    "Bob McDonald is a business development professional and entrepreneur with over 15 years of experience in the healthcare and technology industries. He has a track record of success in bringing innovative technologies to market and helping businesses grow and succeed. As a business development professional, Bob has a deep understanding of the key drivers of success in these industries, including market trends, customer needs, and competitive landscape."
                  }
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3">
                <TeamTitle>Advisors</TeamTitle>
              </div>
              <TeamMember
                img={rockMackie}
                name={"Rock Mackie, PhD"}
                job={"Industry and Technology Advisor"}
                text={
                  "Rock Mackie, PhD is a medical physicist, entrepreneur and Emeritus Director of Medical Engineering at the Morgridge Institute for Research."
                }
              />
              <TeamMember
                img={aimeeArnoldussen}
                name={"Aimee Arnoldussen, PhD"}
                job={"Technology and Industry Advisor"}
                largetext={true}
                text={
                  "Aimee Arnoldussen, PhD is an Innovation Mentor at UW Madison. Dr. Arnoldussen has an integrated background in research, business, healthcare. She received her PhD in Neuroscience from UW Madison, MS in Biology from University of Southern California and a BS/BA in Cognitive Science and Human Development from the University of California, San Diego. She joined the startup Wicab Inc. to commercialize the BrainPort vision device for those who are blind based upon the concept of neuroplasticity. This medical device successfully gained FDA 510(k) de novo clearance in 2015 and is now commercially available.  Her commercialization research was awarded over $6M in non-dilutive funding from the NIH and Department of Defense that led to venture funding exceeding $7M. Her work has been featured in magazines, newspapers and TV. Dr. Arnoldussen’s expertise was then tapped to manage the UW Health Technology Assessment Program, providing evidence-based value analyses of healthcare technologies to guide strategic organizational and purchasing decisions."
                }
              />
              <TeamMember
                img={onur}
                name={"Onur Asan, PhD"}
                job={"Technology and Industry Advisor"}
                largetext={true}
                text={
                  "Dr. Onur Asan  is an Associate Professor at Stevens Institute of Technology. He completed his Ph.D. in Industrial and Systems engineering at University of Wisconsin-Madison, specializing in human factors and human-computer interaction. Dr. Asan's research focuses on application of theory, methods and design from the discipline of human factors engineering and human computer interaction to improve socio-technical change in health care. In particular, Dr. Asan has been studying how new technologies, and organizational initiatives transform a) ambulatory and hospital work systems, b) patient centred care/communication, c) care coordination and workflow, and d) outcomes including patient safety, trust, quality of care and employee well-being."
                }
              />
            </div>
            
            <div className="col-lg-12">
              <div className="mb-5">
                <div style={{margin:"auto",width:"fit-content"}}>
                <TeamTitle center={true} width={150} bottom={20}>Board Members</TeamTitle>
                </div>
                
              </div>
              <div className="row">
              <div className="col-lg-6">
              <TeamMember
                  img={jenniferCarter}
                  name={"Jennifer Carter, JD"}
                  job={"Co-founder and Board Member"}
                  text={
                    "Jennifer Carter is an attorney with experience in healthcare IT and business law."
                  }
                />
                
                
                <TeamMember
                  img={jimSendecke4}
                  name={"Jim Sendecke"}
                  largetext={true}
                  job={"Board Member"}
                  text={
                    "Jim Sendecke is the retired CEO of Reed/Sendecke/ Krebsbach Inc. which is a design, advertising and marketing communications- firm.  He co-founded the firm and was with the firm for 40 years.  Prior to that he was in business development and PR with the Durant Group for 5 years and with Xerox in their sales and marketing department for 3 years.  He is a past president and board member of Madison Advertising Federation and a retired board member of Breast Cancer Recovery.  He is a pilot and enjoys flying, motorcycling, golfing, fishing and family time with his 2 children and 7 grandchildren."
                  }
                />
              </div>
              <div className="col-lg-6">
              <TeamMember
                  img={bobOkeefe2}
                  name={"Bob O'Keefe"}
                  largetext={true}
                  job={"Board Member"}
                  text={
                    "Robert O'Keefe is presently the CFO at Mount Mary University in Milwaukee, Wisconsin.  For the prior 25 years, he served in the healthcare system arena, including CFO at UW Hospitals and Clinics in Madison, Wisconsin and Vice President of Finance for Aurora Health Care in Milwaukee, Wisconsin.  He has been active on numerous healthcare enterprise boards of directors, as well as a frequent speaker at national and regional conferences of healthcare associations."
                  }
                />
                <TeamMember
                  img={mikeYaktus2}
                  name={"Mike Yaktus"}
                  job={"Board Member"}
                  largetext={true}
                  text={
                    "Mike Yaktus  was a CPA with Grant Thornton, a CFP with Kemper Financial, and before retiring, was a Managing Director with Madison Investment Advisors.  He holds a BBA from University of Wisconsin Oshkosh with majors in Accounting and Finance.  He has served on numerous Boards, including Agrace Hospice, Big Brothers Big Sisters and the Nakoma Foundation.  Currently he serves as the General Partner with an Angel Investment Group."
                  }
                />
              </div>
              </div>
            </div>
          </div>
          
        </div>
      </section>
    </>
  )
}

export default Team